import React, {useContext, useEffect, useState, useRef} from 'react';
import { useNavigate, useParams } from "react-router-dom";
import { InputContext } from '../contexts/InputContext';
import resourcesServices from '../services/resourcesServices';
import { errorMessage } from '../errorHandler';
import { useReactToPrint } from 'react-to-print';
import BotonVolver from '../components/BotonVolver';
import ComprobanteEnvio from '../components/ComprobanteEnvio';

const NotificacionShow = () => {
  const printComponentRef = useRef();
  const printComprobanteRef = useRef();

  let { id } = useParams();
  const navigate = useNavigate();
  const [authInformation, setAuthInformation] = useContext(InputContext);
  const [renderHTML, setRenderHTML] = useState(false);
  const [notificacion, setNotificacion] = useState(false);

  useEffect(() => {
    if(authInformation.autenticado === false){
      navigate(`/ingreso`);
    } else if( authInformation.autenticado === true){
      setRenderHTML(true)
      fetchNotificacion(id)
    } else {
      setRenderHTML(false)
    }
  }, [authInformation, id]);


  const fetchNotificacion = async (id) => {
    try {
      const data = await resourcesServices.obtenerResourcePorId('notificaciones', id);
      setNotificacion(data);

    } catch (error) {
      errorMessage(error)
    }
  };

  const handlePrint = useReactToPrint({
    content: () => printComponentRef.current,
  });

  const handlePrintComprobante = useReactToPrint({
    content: () => printComprobanteRef.current,
  });

  return (
    <div>
      {renderHTML && (
        <div>
          <div className="card" ref={printComponentRef}>
            <div className="card-header pb-0">
              <h3><span className="badge text-bg-warning me-3">{notificacion.tipo}</span>{notificacion.asunto} <BotonVolver/></h3>
              {/* <pre>{JSON.stringify(notificaciones, null, 2)}</pre> */}
            </div>
            <div className="card-body px-3">
              <div dangerouslySetInnerHTML={{__html: notificacion.mensajeHTML}} />
              {
                notificacion.archivos_adjuntos && notificacion.archivos_adjuntos.length > 0 && (
                  <div className='card mt-3 mb-3 border-top'>
                    <ul className='list-group list-group-flush'>
                    {
                      notificacion.archivos_adjuntos.map((adjunto, index) => (
                        <li key={index} className='list-group-item'>
                          {adjunto.nombre}
                          <a href={adjunto.url} rel="noreferrer" target='_blank' className='btn btn-success ms-3'>Descarcar</a>
                        </li>
                      ))
                    }
                    </ul>
                  </div>
                )
              }
            </div>
            <div className="card-footer">
              <div className='row'>
                <div className='col-6 text-start'>
                  <div className='blockquote-footer'><b>Obligado:</b> {notificacion.usuario_notificado && notificacion.usuario_notificado.value}</div>
                  <div className='blockquote-footer'><b>Notificador:</b> {notificacion.usuario_notificador && notificacion.usuario_notificador.value}</div>

                </div>
                <div className='col-6 text-end'>
                  <div className='blockquote-footer'><b>Fecha de envío:</b> {notificacion.fecha_envio}</div>
                  <div className='blockquote-footer'><b>Fecha de apertura:</b> {notificacion.fecha_lectura}</div>
                </div>
              </div>
            </div>

          </div>
          <button onClick={handlePrint} className='btn btn-info mt-5'>Imprimir</button>
          {
            authInformation.rol !== 'Obligado' && authInformation.rol !== 'Apoderado' && (
              <button onClick={handlePrintComprobante} className='ms-3 btn btn-info mt-5'>Imprimir Comprobante de Envío</button>
            )
          }

          <ComprobanteEnvio data={notificacion} fechaEnvio={notificacion.fecha_envio} refValue={printComprobanteRef} />
        </div>
      )}
    </div>
  );
};

export default NotificacionShow;
